import { render, staticRenderFns } from "./common-message-dialog.vue?vue&type=template&id=db06c64c&scoped=true&"
import script from "./common-message-dialog.vue?vue&type=script&lang=js&"
export * from "./common-message-dialog.vue?vue&type=script&lang=js&"
import style0 from "./common-message-dialog.vue?vue&type=style&index=0&id=db06c64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db06c64c",
  null
  
)

export default component.exports